/* eslint-disable @typescript-eslint/no-require-imports */
import type { ImgHTMLAttributes } from 'react';

const getGoalImageUrl = (slug: string, inactive: boolean) => {
  try {
    return require('@resources/img/account/rewards/goals/' + slug + (inactive ? '_inactive' : '') + '.svg?url') as string;
  } catch {
    return undefined;
  }
}

interface GoalImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  inactive?: boolean
  slug: string
}

export default function GoalImage(props: GoalImageProps) {
  const {
    inactive = false,
    slug,
    alt = '',
    style,
    ...imageProps
  } = props;
  const imageUrl = getGoalImageUrl(slug, inactive);

  if (imageUrl === undefined) {
    return null;
  }

  return <img
    {...imageProps}
    src={imageUrl}
    alt={alt}
    style={{
      width: '100%',
      height: 'auto',
      ...style,
    }}
  />
}
